import { put, call } from "redux-saga/effects";
import { readingConstants } from "../actions/constants/readingConstants";
import { ReadingService } from "../services/api/readingService";
import { exceptionHandler } from "../pages/common/functions";

function* readingSave(request: any) {
    try {
		const result = yield call(ReadingService.readingSave, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: readingConstants.ReadingSaveSuccess,
				payload: res.data,
				input: request.input
        });
      }
      else {
			yield put({ type: readingConstants.ReadingSaveFailure, payload: res.data });
      }
    } catch (error) {
		yield put({ type: readingConstants.ReadingSaveFailure, payload: error });
    }
  }
  
function* readingGetDetail(request: any) {
    try {
		const result = yield call(ReadingService.readingGetDetail, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
		  yield put({
	      type: readingConstants.ReadingGetDetailSuccess,
			  payload: res.data,
			  input: request.input
        });
      }
	  else {
		  yield put({ type: readingConstants.ReadingGetDetailFailure, payload: res.data });
      }    
	} catch (error) {
		yield put({ type: readingConstants.ReadingGetDetailFailure, payload: error });
    }
  }
  
function* readingGetByFilter(request: any) {
    try {
		const result = yield call(ReadingService.readingGetByFilter, request.input);
		var res = exceptionHandler(result);
      if (res.status) {
		  yield put({
		  type: readingConstants.ReadingGetByFilterSuccess,
          payload: res.data,
          input: request.input
        });
      }
      else {
		  yield put({ type: readingConstants.ReadingGetByFilterFailure, payload: res.data });
      }
	} catch (error) {
		yield put({ type: readingConstants.ReadingGetByFilterFailure, payload: error });
    }
  }
  
function* readingDelete(request: any) {
    try {
		const result = yield call(ReadingService.readingDelete, request.input);
		var res = exceptionHandler(result);
      if (res.status) {
		  yield put({
			  type: readingConstants.ReadingDeleteSuccess,
				payload: res.data,
				input: request.input,
        });
      }
      else {
		  yield put({ type: readingConstants.ReadingDeleteFailure, payload: res.data });
      }
  
	} catch (error) {
		yield put({ type: readingConstants.ReadingDeleteFailure, payload: error});
    }
}

function* readingTextUpdate(request: any) {
	try {
		const result = yield call(ReadingService.readingTextUpdate, request.input)
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: readingConstants.ReadingTextUpdateSuccess,
				payload: res.data
			})
		} else {
			yield put({ type: readingConstants.ReadingTextUpdateFailure, payload: res.data })
		}
	} catch (error) {
		yield put({ type: readingConstants.ReadingTextUpdateFailure, payload: error })
	}
}

function* readingTitleGetExcludeByBible(request: any) {
	try {
		const result = yield call(ReadingService.radingTitleGetExcludeByBible, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: readingConstants.ReadingTitleGetSuccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: readingConstants.ReadingTitleGetFailure, payload: res.data })
		}
	} catch (error) {
		yield put({ type: readingConstants.ReadingTitleGetFailure, payload: error });
	}
}
  
export const readingSaga = {
	readingSave,
	readingGetDetail,
	readingGetByFilter,
	readingDelete,
	readingTextUpdate,
	readingTitleGetExcludeByBible
}